import { cloneDeep } from 'lodash';

class OfferPeriodFormController {
    constructor($rootScope, $scope, $state, offerService, messageService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.offerService = offerService;
        this.messageService = messageService;
    }

    $onInit () {
        if (this.offer.periods.length > 0) {
            for (let period of this.offer.periods) {
                period.start = (period.start) ? moment(period.start, 'YYYY-MM-DD') : '';
                period.end = (period.end) ? moment(period.end, 'YYYY-MM-DD') : '';
            }
        } else {
            this.offer.periods = [{ start: '' }];
        }
    }

    onSave () {
        let periodclone = cloneDeep(this.offer.periods);
        for (let period of this.offer.periods) {
            if (period.start) {
                period.start = period.start.format('YYYY-MM-DD');
            }
            if (period.end && typeof period.end !== 'boolean') {
                period.end = period.end.format('YYYY-MM-DD');
            }
        }

        return this.offerService.savePeriods(this.offer.periods, this.offer.id)
            .then(response => {
                if (!response.error) {
                    if (!this.offer.events) {
                        this.messageService.success(`The special offer <strong>${this.offer.name}</strong> was successfully updated!`);
                        this.$state.go('app.admin.offer-edit', { offer: this.offer.id, tab: 'events' });
                    } else {
                        this.messageService.success(`The special offer <strong>${response.name}</strong> was successfully updated.`, [`app.admin.offer-edit({ 'offer' : ${this.offer.id}})`, `Offer`]);
                        this.$state.go('app.admin.offers');
                    }
                } else {
                    let errorlist = '';
                    for (let error of response.error) {
                        errorlist += `<li>Conflicting offer period <strong>${error.period.start}</strong> - <strong>${error.period.end}</strong> due to <strong>${error.event}</strong> on offer <strong>${error.offer}</strong></li>`;
                    }
                    this.messageService.failure(`The offer periods could not be successfully updated:\n<ul>` + errorlist + `</ul>`);
                    this.messageService.push();
                }
                this.offer.periods = periodclone;
            })
            .catch((error) => {
                this.messageService.failure(`The offer <strong>${this.offer.name}</strong> could not be successfully created: ${error.statusText}`);
                this.messageService.push();
                var sourceElement = Object.keys(error.data)[0];
                if (sourceElement > 0) {
                    this.$scope.$ctrl.form[sourceElement].$setValidity(sourceElement, false);
                } else {
                    this.$scope.$ctrl.form.$setValidity(sourceElement, false);
                }
            });
    }
}

OfferPeriodFormController.$inject = ['$rootScope', '$scope', '$state', 'offerService', 'messageService'];

export default OfferPeriodFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/offer/controllers/offer.period.form.controller.js